import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';


import { FullCalendarModule } from '@fullcalendar/angular' // must go before plugins
// import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
// import interactionPlugin from '@fullcalendar/interaction' // a plugin!


import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule,HTTP_INTERCEPTORS  } from '@angular/common/http';
import { AuthInterceptorService } from './auth-interceptor.service';
import { Animation } from '@ionic/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { SyncedCookieService } from './api/settings-sync.service';

import { SharedModule } from './components/shared/shared.module';
import { TableModule } from 'primeng/table';
import { QuillModule } from 'ngx-quill';


import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { DocumentEditorModule } from '@txtextcontrol/tx-ng-document-editor';



@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot({
    animated: false

  }), AppRoutingModule, HttpClientModule, BrowserAnimationsModule, SharedModule, TableModule, GooglePlaceModule, FullCalendarModule,
    // Default toolbar for every quill-editor that doesn't set its own [modules] - the stock one minus image/video, so files can't be inserted
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{ header: 1 }, { header: 2 }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }],
          [{ indent: '-1' }, { indent: '+1' }],
          [{ direction: 'rtl' }],
          [{ size: ['small', false, 'large', 'huge'] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          [{ font: [] }],
          [{ align: [] }],
          ['clean'],
          ['link']
        ]
      }
    })],
  // SyncedCookieService is the normal cookie service plus reporting every settings cookie change to SettingsSyncService,
  // which saves them to the user's account (see api/settings-sync.service.ts)
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, { provide: CookieService, useClass: SyncedCookieService },{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }],
  bootstrap: [AppComponent],
})
export class AppModule {

}
